import React from "react";
import { CheckIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerStack } from "../../data/content";
const perks = ["One-Time Payment", "Lifetime Access", "No Monthly Fees", "Instant Digital Access"];
export function Offer() {
  const total = offerStack.reduce((sum, i) => sum + i.value, 0);
  return <section id="offer" className="w-full bg-brand-olive px-5 py-16 md:py-24" data-id="element-243" data-mp="3a56w8obvs3e4">
      <div className="mx-auto max-w-2xl" data-id="element-244" data-mp="3f38nhwjgn90o">
        <p className="text-center font-display text-sm uppercase tracking-[0.2em] text-brand-mist/80" data-id="element-245" data-mp="3jv8jxf0bnjsi">Special launch offer</p>
        <h2 className="mt-3 text-center font-serif text-[32px] font-bold leading-tight text-cream md:text-5xl" data-id="element-246" data-mp="3nxda23rk9yae">
          Here's everything you're getting today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-paper shadow-[0_30px_60px_-30px_rgba(0,0,0,0.5)]" data-id="element-247" data-mp="1pn63y6ib13a">
          <img src={images.mainMockup} alt="Everything included in The Aroma Lab" className="w-full bg-cream" data-id="element-248" data-mp="1kl8aqym9djbu" />

          <div className="px-5 pb-8 pt-6 md:px-10" data-id="element-249" data-mp="1fm40e4nllfjx">
            <ul className="divide-y divide-ink/10" data-id="element-250" data-mp="1fohv2ced8pqy">
              {offerStack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-251" data-mp="1bmw9m2nrn355">
                  <span className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-252" data-mp="16ns0td4r77fc">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-cta" aria-hidden="true" data-id="element-253" data-mp="23bg973f0jllp" />
                    <span className={item.main ? "font-bold" : ""} data-id="element-254" data-mp="1zb621nfhip59">{item.label}</span>
                  </span>
                  <span className="shrink-0 text-[15px] text-ink/55 line-through" data-id="element-255" data-mp="1uhjm9me0y558">${item.value}</span>
                </li>)}
            </ul>

            <div className="mt-4 flex items-center justify-between rounded-xl bg-brand-blush px-4 py-3" data-id="element-256" data-mp="2n0714k2fgnxv">
              <span className="text-sm font-bold uppercase tracking-widest text-brand-rose" data-id="element-257" data-mp="2i877f9cyar9q">Total value</span>
              <span className="font-serif text-2xl font-bold text-brand-rose line-through" data-id="element-258" data-mp="316s74275cjjk">${total}</span>
            </div>

            <div className="mt-8 text-center" data-id="element-259" data-mp="366odu978ap2t">
              <p className="text-[15px] font-semibold uppercase tracking-wider text-ink/70" data-id="element-260" data-mp="2sdows2rssmt5">
                But today, you can get everything for…
              </p>
              <p className="mt-2 font-serif text-[88px] font-extrabold leading-none text-brand-cta md:text-[112px]" data-id="element-261" data-mp="2wcea5vcu64cs">
                <span className="align-top text-4xl md:text-5xl" data-id="element-262" data-mp="2ndswoem81fiv">$</span>27
              </p>
              <p className="mt-2 text-sm text-ink/60" data-id="element-263" data-mp="29eb3zo5t1i48">USD · Your currency is converted automatically</p>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-264" data-mp="2df4p69rv4itf">
              {perks.map(p => <li key={p} className="flex items-center gap-2 rounded-xl bg-brand-mist px-3 py-2.5 text-[14px] font-semibold text-brand-olive" data-id="element-265" data-mp="7met8grgocai">
                  <CheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-266" data-mp="bnqjmoi5t1jr" />
                  {p}
                </li>)}
            </ul>

            <p className="mt-6 text-center text-[16px] leading-relaxed text-ink/80" data-id="element-267" data-mp="1s5igt3og0fr6">
              You don't need another expensive course, a monthly membership, or complicated software. You get the complete
              Aroma Lab system and the 5 bonus resources for <strong data-id="element-268" data-mp="213khfi49l6dx">one simple payment</strong>.
            </p>

            <div className="mt-8" data-id="element-269" data-mp="2ft8gsdsvxuz0">
              <CtaButton label="I Want The Aroma Lab™" sub="Only $27 · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-270" data-mp="2fwnvhfind1zw" />
            </div>

            <div className="mt-8" data-id="element-271" data-mp="2ovhqx2k8rmbv">
              <Countdown note="Launch pricing available for a limited time." data-id="element-272" data-mp="2ougfgwzbcxtm" />
            </div>

            <div className="mt-6 flex justify-center" data-id="element-273" data-mp="2jwofdfoim5ec">
              <ScarcityBar data-id="element-274" data-mp="ugoy1baqt9nm" />
            </div>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-[13px] text-ink/55" data-id="element-275" data-mp="uhguspg2tdfh">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-276" data-mp="pjyicp2uog2q" />
              Secure checkout · 256-bit encryption
            </p>
          </div>
        </div>
      </div>
    </section>;
}